import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1e679b59")
const _hoisted_1 = { class: "albums" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButtonComponent = _resolveComponent("BackButtonComponent")!
  const _component_AlbumComponent = _resolveComponent("AlbumComponent")!
  const _component_AssetComponent = _resolveComponent("AssetComponent")!
  const _component_perfect_scrollbar = _resolveComponent("perfect-scrollbar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['albums-wrapper', {'is-open-album': _ctx.currentAlbum }])
  }, [
    (_ctx.currentAlbum)
      ? (_openBlock(), _createBlock(_component_BackButtonComponent, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_perfect_scrollbar, { options: { wheelPropagation: false } }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.currentAlbum)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.currentAlbumHasChildren)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.childAlbums, (album) => {
                      return (_openBlock(), _createBlock(_component_AlbumComponent, {
                        key: album.id,
                        album: album
                      }, null, 8, ["album"]))
                    }), 128))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.currentAlbum.assets, (asset) => {
                      return (_openBlock(), _createBlock(_component_AssetComponent, {
                        key: asset.id,
                        asset: asset
                      }, null, 8, ["asset"]))
                    }), 128))
              ], 64))
            : (!_ctx.dataLoadingInProgress && _ctx.rootAlbums.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rootAlbums, (album) => {
                    return (_openBlock(), _createBlock(_component_AlbumComponent, {
                      key: album.id,
                      album: album
                    }, null, 8, ["album"]))
                  }), 128)),
                  _createVNode(_component_AlbumComponent, {
                    newest: "",
                    album: _ctx.newestAlbum
                  }, null, 8, ["album"])
                ], 64))
              : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ], 2))
}